const customMetadataLimits = {
    key: 64,
    value: 64000,
    fields: 256,
};
export const validateCustomMetadata = ({ item, ctx, customSchema }) => {
    if (item.custom_metadata == null)
        return;
    const { custom_metadata: customMetadata } = item;
    let fields = Object.entries(customMetadata);
    if (fields.length > customMetadataLimits.fields) {
        fields = fields.slice(0, customMetadataLimits.fields);
        ctx.addWarn(`Too many custom metadata entry. Found ${fields.length}, maximum ${customMetadataLimits.fields}. Extra entries will not be imported.`);
    }
    const fieldEntries = Object
        .entries(customMetadata)
        .map(([key, value]) => {
        if (key == null || key === '') {
            ctx.addWarn(`Bad custom metadata entries. Entry key is empty. Entry will be skipped.`);
            return [];
        }
        if (value == null || value === '') {
            ctx.addWarn(`Bad custom metadata entry. Entry value is empty. Entry will be skipped.`);
            return [];
        }
        if (key.length > customMetadataLimits.key) {
            const newKey = key.slice(0, customMetadataLimits.key);
            ctx.addWarn(`Custom metadata entry key starting with "${key.slice(0, 10)}" label is too long. Found ${key.length}, maximum ${customMetadataLimits.key}. Entry key will be truncated.`);
            key = newKey;
        }
        if (value.length > customMetadataLimits.value) {
            const newValue = value.slice(0, customMetadataLimits.value);
            ctx.addWarn(`Custom metadata entry key "${key}" value is too long. Found ${value.length}, maximum ${customMetadataLimits.value}. Entry value will be truncated.`);
            value = newValue;
        }
        return [key, value];
    })
        .filter(f => f === null || f === void 0 ? void 0 : f.length);
    item.custom_metadata = Object.fromEntries(fieldEntries);
};
